import FormBaseModel from '@cp-models/FormBaseModel';

export default class Discount extends FormBaseModel {
    casts()
    {
        return {
            'id': 'number',
            'internal_id': 'number',
            'module_id': 'number',
            'plan_products_id': 'number',
            'discount_item_id': 'number',
            'vindi_id': 'number',
            'percentage': 'number',
            'value': 'number',
            'due_at': 'any',
            'due_date': 'any',
        }
    }

    get valueBr()
    {
        return this.formatCurrency(this.value)
    }

    get dueAt()
    {
        return this.due_at
            ? this.formatDate(this.due_at)
            : this.formatDate(this.due_date)
    }

}
